'use strict';

import { BaseElement } from '../../interfaces/BaseElement';
import { getDocuments } from '../../crm/crm-requests';
import { changeLangToCurrent, getCurrentLang } from '../../components/langSwitcher/langSwitcher';
import { isMobile } from '../../../settings';
import { PreviewPopUp } from '../../interfaces/pages/Preview';

export class Documents {
	static scopes = [];
	static active = false;
	
	constructor (parent = null) {
		this.data = config.documents;
		this.parent = parent;
		this.tabs = {};
		this.activeTab = null;
	}
	
	getData () {
		return new Promise(resolve => {
			getDocuments().then(response => {
				const data = JSON.parse(JSON.stringify(response.data));
				data.sort((a, b) => a.order - b.order);
				config.documents = data;
				resolve(data);
			});
		});
	}
	
	
	async create () {
		if (!this.data) {
			this.data = await this.getData();
		}
		
		const currentLang = getCurrentLang();
		this.mainContainer = new BaseElement()
			.addClass('documents', 'background-backdrop-filter')
			.appendTo(this.parent)
			.DOMElement;
		
		const navBar = new BaseElement()
			.addClass('documents-nav-bar', 'background-backdrop-filter', 'widget-menu__items')
			.event('click', this.navBarHandler.bind(this))
			.appendTo(this.mainContainer)
			.DOMElement;
		
		if (this.data.length < 2) {
			navBar.classList.add('hidden');
		}
		
		const tabs = new BaseElement()
			.addClass('documents-tabs')
			.appendTo(this.mainContainer)
			.DOMElement;
		
		this.data.forEach((tabContent, index) => {
			if (!tabContent.documents.length) return;
			
			const navButtonName = getValue(tabContent.name, currentLang);
			const navButton = new BaseElement('button')
				.addClass('gallery__tab__btn', 'text', 'documents-nav-bar__button')
				.addAttribute('data-tab-id', tabContent.categoryId)
				.innerHtml(navButtonName)
				.appendTo(navBar)
				.DOMElement;
			
			if (this.data.length - 1 !== index) {
				new BaseElement('span')
					.addClass('widget-menu__separator')
					.appendTo(navBar);
			}
			
			const descriptionText = 'Documents to download';
			new BaseElement()
				.addClass('documents-description')
				.innerHtml(changeLangToCurrent(descriptionText))
				.addAttribute('data-dictionary', descriptionText)
				.appendTo(tabs);
			
			const tab = new BaseElement()
				.addClass('documents-tab', 'hidden')
				.addAttribute('data-tab-id', tabContent.categoryId)
				.appendTo(tabs)
				.DOMElement;
			
			this.tabs[tabContent.categoryId] = {
				tab,
				button: navButton,
			};
			
			tabContent.documents.forEach(document => {
				const title = getValue(document.title, currentLang);
				const url = getValue(document.fileUrl, currentLang);
				this.#setDocumentInterface({tab, title, url});
			});
		});
		
		if (Object.keys(this.tabs).length < 2) {
			navBar.classList.add('hidden');
		}
		
		if (this.activeTab) {
			this.setActive(this.activeTab.tab.dataset.tabId);
		} else {
			this.setActive(this.data[0].categoryId);
		}
		
		Documents.addToScopes(this);
	}
	
	#setDocumentInterface ({tab, title, url}) {
		const documentItem = new BaseElement()
			.addClass('documents-item')
			.appendTo(tab);
		const urlSplit = url.split('.');
		const fileExtension = urlSplit[urlSplit.length - 1].toLowerCase();
		let iconClass = 'document-clear';
		switch (fileExtension) {
			case 'pdf':
				iconClass = 'document-pdf';
				break;
		}
		new BaseElement()
			.addClass('documents-item__icon', iconClass)
			.appendTo(documentItem.DOMElement);
		new BaseElement('h1')
			.addClass('documents-item__title', 'language-string')
			.innerHtml(changeLangToCurrent(title))
			.addAttribute('data-dictionary', title)
			.appendTo(documentItem.DOMElement);
		const link = new BaseElement('a')
			.addClass('documents-item__action-button', 'language-string')
			.innerHtml(changeLangToCurrent('Open'))
			.setAttributes({
				'href': url,
				'data-dictionary': 'Open',
			})
			.appendTo(documentItem.DOMElement);
		
		if (isMobile) {
			link
				.innerHtml('')
				.deleteAttribute('data-dictionary')
				.deleteAttribute('href')
				.deleteAttribute('download')
				.deleteAttribute('target')
				.addClass('icon-download');
			
			documentItem
				.event('click', (e) => {
				    e.preventDefault();
					if (url) {
						const newWindow = window.open(url, '_blank');
						if (newWindow) {
							newWindow.focus();
						} else {
							console.warn('Popup might be blocked or URL is invalid:', url);
						}
					}
				});
		} else {
			link.event('click', (e) => {
				e.preventDefault();
				new PreviewPopUp(url);
			});
		}
	}
	
	setActive (id) {
		const selectedTab = this.tabs[id];
		if (selectedTab) {
			if (this.activeTab) {
				this.activeTab.button.classList.remove('active');
				this.activeTab.tab.classList.add('hidden');
			}
			
			selectedTab.button.classList.add('active');
			selectedTab.tab.classList.remove('hidden');
			this.activeTab = selectedTab;
		}
	}
	
	changeLanguage () {
		this.mainContainer.remove();
		this.create();
	}
	
	navBarHandler (e) {
		const id = e.target.dataset.tabId;
		if (id) {
			this.setActive(id);
		}
	}
	
	static changeLanguage () {
		Documents.scopes.forEach(scope => scope.changeLanguage());
	}
	
	static addToScopes (scope) {
		const inScopes = Documents.scopes.find(scopes => scopes === scope);
		if (!inScopes) {
			Documents.scopes.push(scope);
		}
	}
	
}

function getValue (inputArray, currentLang) {
	let value = inputArray.find(obj => obj.lang === currentLang)?.value;
	if (!value) {
		inputArray.forEach(el => {
			if (el.value) {
				value = el.value;
			}
		});
	}
	
	return value;
}
